module.exports = __webpack_public_path__ + "static/media/social-media.68169a7f.svg";